import React, {useState} from "react";
import {toast} from "react-toastify";
import axios from "axios";
import {getMessageFromError} from "@/global/helpers/getMessageFromError";
import {BackLink} from "@/global/components/BackLink";
import {Alert, Button, Stack, Typography} from "@mui/material";
import {PhoneInput} from "@/global/components/PhoneInput";

interface Props {
    returnFirstStep:  () => void;
}

export function NoStudent ({returnFirstStep}:Props) {

    const [phone, setPhone] = useState<{
        phone: string,
        isValid: boolean
    }>({
        phone: '',
        isValid: false
    });

    const onSubmit = () => {
        if (!phone.isValid) {
            toast.error('Неверный номер телефонв');
            return;
        }
        axios.post('https://api.pddtest.kz/crm/public/create_card/190f21084af1934057_avtomektep',  {
            phone: phone.phone
        })
            .then(() => {
                toast.success('Заявка отправлена');
                returnFirstStep();
            })
            .catch((error) => {
                toast.error(`Ошибка при отправке заявки: ${getMessageFromError(error)}. Повторите попытку позже`);
            });
    };

    return (
        <>
            <BackLink
                label={'Вернуться к вводу ИИН'}
                onClick={returnFirstStep}
                sx={{
                    alignSelf: 'flex-start'
                }}
            />
            <Stack
                display={'flex'}
                flexDirection={'column'}
                sx={{
                    width: {lg: '60%', xs: '100%'},
                    borderRadius: '26px',
                    backgroundColor: '#FFFFFF',
                    padding: 3,
                    gap: '16px'
                }}
            >
                <Alert severity={'info'}>
                    По данному ИИН не найдено данных об
                    обучении.
                </Alert>
                <Typography>
                    Для уточнения информации оставьте свой номер
                </Typography>
                <PhoneInput
                    label={'Телефон'}
                    onChange={(phone, isValid) => setPhone({
                        phone,
                        isValid
                    })}
                />
                <Button
                    variant={'contained'}
                    onClick={onSubmit}
                >
                    Отправить
                </Button>
            </Stack>
        </>
    );
}